// components/layout/UserMenu.tsx
import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box,
} from '@mui/material';
import {
  Person,
  Settings,
  Logout,
  Info,
} from '@mui/icons-material';
import { useAppDispatch } from '../../hooks/redux';
import { logoutAsync } from '../../store/slices/authSlice';
import { User } from '../../types';

interface UserMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  user: User | null;
}

const UserMenu: React.FC<UserMenuProps> = ({
  anchorEl,
  open,
  onClose,
  user,
}) => {
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    await dispatch(logoutAsync());
    onClose();
  };

  const handleProfile = () => {
    // Tutaj będzie logika profilu
    console.log('Otwórz profil użytkownika');
    onClose();
  };

  const handleSettings = () => {
    // Tutaj będzie logika ustawień
    console.log('Otwórz ustawienia');
    onClose();
  };

  const handleAbout = () => {
    // Tutaj będzie logika informacji o aplikacji
    console.log('Informacje o aplikacji');
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="user-menu"
      open={open}
      onClose={onClose}
      onClick={onClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          minWidth: 200,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {user && (
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            {user.fullName} {user.fullName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user.email}
          </Typography>
        </Box>
      )}
      
      <Divider />
      
      <MenuItem onClick={handleProfile}>
        <ListItemIcon>
          <Person fontSize="small" />
        </ListItemIcon>
        <ListItemText>Profil</ListItemText>
      </MenuItem>
      
      <MenuItem onClick={handleSettings}>
        <ListItemIcon>
          <Settings fontSize="small" />
        </ListItemIcon>
        <ListItemText>Ustawienia</ListItemText>
      </MenuItem>
      
      <Divider />
      
      <MenuItem onClick={handleAbout}>
        <ListItemIcon>
          <Info fontSize="small" />
        </ListItemIcon>
        <ListItemText>O aplikacji</ListItemText>
      </MenuItem>
      
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText>Wyloguj</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default UserMenu;